<template>
    <v-card elevation-3 class="azul--text">
        <v-card-title>Filtros</v-card-title>
        <v-card-subtitle class="azul--text py-0">
            Filtrar por Laboratorio
        </v-card-subtitle>
        <v-card-text>
            <!-- contenedor -->
            <div class="container fluid">
                <div v-for="laboratorio in laboratorios" :key="laboratorio.id">
                    <div class="d-block">
                        <v-checkbox
                            v-model="selectedLabs"
                            class="azul--text"
                            color="azul"
                            hide-details
                            :label="laboratorio.descripcion"
                            :value="laboratorio.grupo1"
                        />
                    </div>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    data: () => ({
        selectedLabs: [],
        filterLabs: [
            'ASTR',
            'BAYE',
            'PFIZ',
            'ELEA',
            'GADO',
            'GLAX', //Glaxo
            'MSD', //MSD
            'NUBA', //Nutricia Bago adultos
            'NUTR', //Nutricia Bago infantil
            'SANO', //Sanofi Aventis
            'ROCH', //Roche
            'TEVA', //Teva
            'ANDR', //Andromaco
            'SANP', //Sanofi Pasteur
            'ABBN', //Aboot nutricion
            'ABBR' //Abbot
        ]
    }),

    computed: {
        ...mapState('laboratorios', ['laboratorios'])
    },
    watch: {
        selectedLabs() {
            this.$emit('change', this.selectedLabs);
        }
    },

    async mounted() {
        await this.getLaboratorios();
        if (this.$route.query.lab) {
            this.selectedLabs = [
                this.laboratorios.find(
                    l => l.grupo1.trim() === this.$route.query.lab
                ).grupo1
            ];
        }
    },
    methods: {
        ...mapActions('laboratorios', ['getLaboratorios'])
    }
};
</script>
<style scoped>
.azul--text /deep/ label {
    color: #184087;
}
</style>
